import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Group, Input as RACInput, composeRenderProps } from 'react-aria-components';
import { Size } from '../../constants/size.js';
import { twMerge } from '../../utils/twMerge.js';
/**
 * Styled browser `<input>` element. Meant to be used as part of `<TextField>`. Should only be used directly when constructing custom input types.
 */
export const Input = forwardRef(function Input({ className, inputClassName, prefix, suffix, size = Size.Default, ...inputProps }, forwardedRef) {
    return (_jsxs(Group, { className: composeRenderProps(className, (className) => twMerge(
        // component name
        'ppl-Input', 
        // base styles
        'inline-flex items-center gap-1 rounded border border-default bg-default px-2 text-default shadow outline outline-1 -outline-offset-1 outline-transparent transition-[box-shadow,border-color,outline]', 
        // hover states
        'hover:border-default-hover hover:shadow-md', 
        // focus within states
        'focus-within:outline-accent-bold focus-within:ring focus-within:ring-accent/[.38] focus-within:ring-offset-0', 
        // invalid states
        'invalid:border-critical', 
        // invalid hover states
        'invalid:hover:border-critical-hover', 
        // invalid focus within states
        'invalid:focus-within:outline-critical invalid:focus-within:ring-critical/[.38]', 
        // disabled states
        'disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-default-bold disabled:opacity-40', 
        // sizes
        {
            compact: 'h-6',
            default: 'h-8',
            loose: 'h-10',
        }[size], 
        // user styles
        className)), children: [typeof prefix === 'string' ? _jsx("div", { className: "text-body-md text-default-subdued", children: prefix }) : prefix, _jsx(RACInput, { ...inputProps, ref: forwardedRef, className: composeRenderProps(inputClassName, (className) => twMerge('w-full flex-grow appearance-none text-ellipsis border-none bg-transparent text-body-md text-default outline-none placeholder:text-default-subdued/60', className)) }), typeof suffix === 'string' ? _jsx("div", { className: "text-body-md text-default-subdued", children: suffix }) : suffix] }));
});
//# sourceMappingURL=Input.js.map